import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null,
};

const userExpertReducer = createReducer(initialState, {
  USER_EXPERT_REQ: (state) => {
    state.loading = true;
    state.data = null;
  },
  USER_EXPERT_FETCH_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  USER_EXPERT_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default userExpertReducer;
